import { Component, OnInit, inject } from '@angular/core';
import { AuthService } from '../../route/auth/auth.service';
import { AppUrls } from '../../route/app-urls';
import { AppConfig } from '../../appconfig';
import { TranslateService } from '@ngx-translate/core';
import { SettingsService } from '../../shared/settings/settings.service';


@Component({
    selector: 'ldw-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: false
})
export class LoginComponent implements OnInit{
  private authService = inject(AuthService);
  private config = inject(AppConfig);
  private settingsService = inject(SettingsService);
  private translate = inject(TranslateService);

  constructor() {}
  public longVersion = '';
  public errorText = '';
  ngOnInit(): void {
    this.longVersion = 'Version ' + this.config.version();
  }

  login(e: any) {
    console.log('... logging in ...');
    this.authService.login(AppUrls.baseUrlAngular);
  }

  showToolTip(): boolean {
    return this.settingsService.settings.viewMode.showTooltips;
  }

  showImprint(): boolean {
    return this.config.hasImprintLink();
  }

  showPrivacy(): boolean {
    return this.config.hasPrivacyLink();
  }

  showServerInfo(): boolean {
    return this.config.hasServerInfo();
  }

  urlImprint(): string {
    return this.config.urlImprint();
  }

  textImprint(): string {
    return this.config.textImprint();
  }

  urlPrivacy(): string {
    return this.config.urlPrivacy();
  }

  textPrivacy(): string {
    return this.config.textPrivacy();
  }

  serverInfo(): string {
    return this.config.serverInfo();
  }

  loginAllowed(): boolean {
    return !this.config.isLocked();
  }

  hasMessage(): boolean {
    return this.config.messageHeader().length > 0;
  }

  messageHeader(): string {
    return this.config.messageHeader();
  }

  messageText(): string {
    return this.config.messageText();
  }
}
